import React, { useEffect, useRef, useState } from 'react';
export const useAccessibility = (isOpenSelect, handleChangeSelect, setIsOpenSelect, optionRefs, selectRef, handleFocusCurrentOption) => {
    const selectInputRef = useRef('');
    const [isDebounce, setIsDebounce] = useState(false);
    useEffect(() => {
        if (isDebounce) {
            const timeoutId = setTimeout(() => {
                selectInputRef.current = '';
                setIsDebounce(false);
            }, 2000);
            return () => clearTimeout(timeoutId);
        }
    }, [isDebounce]);
    const arrowNavigateOptions = React.useCallback((direction) => {
        var _a, _b, _c;
        if (isOpenSelect && optionRefs.current != null) {
            const currentIndex = optionRefs.current.findIndex((ref) => ref === document.activeElement);
            let newIndex = currentIndex + direction;
            if (((_a = optionRefs.current[newIndex]) === null || _a === void 0 ? void 0 : _a.dataset.isDisabled) && direction === -1)
                newIndex--;
            if (((_b = optionRefs.current[newIndex]) === null || _b === void 0 ? void 0 : _b.dataset.isDisabled) && direction === 1)
                newIndex++;
            if (newIndex >= 0 && newIndex < optionRefs.current.length) {
                (_c = optionRefs.current[newIndex]) === null || _c === void 0 ? void 0 : _c.focus();
            }
        }
    }, [isOpenSelect, optionRefs]);
    const wordNavigateOptions = React.useCallback((key) => {
        var _a, _b, _c, _d;
        const isValidateString = /^\p{L}+$/u.test(key);
        if (optionRefs.current === null)
            return;
        let focusedIndex = optionRefs.current.findIndex((ref) => ref === document.activeElement);
        const isTextExist = optionRefs.current.findIndex((ref) => { var _a; return ((_a = ref === null || ref === void 0 ? void 0 : ref.dataset.textcontent) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === selectInputRef.current.toLowerCase(); });
        const sameLetters = selectInputRef.current
            .split('')
            .every((letter) => letter.toLowerCase() === selectInputRef.current[0].toLowerCase());
        const setSelectOption = (index) => {
            var _a, _b, _c;
            if (optionRefs.current === null)
                return;
            handleChangeSelect({
                selectValue: (_a = optionRefs.current[index]) === null || _a === void 0 ? void 0 : _a.dataset.index,
                selectName: (_b = optionRefs.current[index]) === null || _b === void 0 ? void 0 : _b.dataset.textcontent,
                selectId: (_c = optionRefs.current[index]) === null || _c === void 0 ? void 0 : _c.dataset.id,
                disabled: false,
            });
        };
        switch (true) {
            case isTextExist !== -1:
                isOpenSelect && ((_a = optionRefs.current[isTextExist]) === null || _a === void 0 ? void 0 : _a.focus());
                !isOpenSelect && setSelectOption(isTextExist);
                break;
            case isValidateString && (selectInputRef.current.length === 1 || sameLetters):
                if (!isOpenSelect)
                    focusedIndex = optionRefs.current.findIndex((ref) => { var _a; return ((_a = ref === null || ref === void 0 ? void 0 : ref.dataset) === null || _a === void 0 ? void 0 : _a.isActive) === 'true'; });
                for (let i = 1; i < optionRefs.current.length; i++) {
                    const nextIndex = (focusedIndex + i) % optionRefs.current.length;
                    if (((_c = (_b = optionRefs.current[nextIndex]) === null || _b === void 0 ? void 0 : _b.dataset.textcontent) === null || _c === void 0 ? void 0 : _c.charAt(0).toLowerCase()) === key.toLowerCase()) {
                        isOpenSelect && ((_d = optionRefs.current[nextIndex]) === null || _d === void 0 ? void 0 : _d.focus());
                        !isOpenSelect && setSelectOption(nextIndex);
                        break;
                    }
                }
                break;
            default:
                return;
        }
    }, [optionRefs, isOpenSelect, selectInputRef]);
    const handleKeyDown = React.useCallback((e, child) => {
        var _a;
        switch (e.key) {
            case ' ':
                e.preventDefault();
                if (child) {
                    (_a = selectRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                    handleChangeSelect({
                        selectValue: child.props.value,
                        selectName: child.props.children || child.props.label,
                        selectId: child.props.id,
                        disabled: false,
                    });
                }
                else {
                    handleFocusCurrentOption();
                }
                setIsOpenSelect((prev) => !prev);
                break;
            case 'ArrowUp':
                e.preventDefault();
                arrowNavigateOptions(-1);
                break;
            case 'ArrowDown':
                e.preventDefault();
                arrowNavigateOptions(1);
                break;
            case 'Enter':
                e.preventDefault();
                break;
            default:
                selectInputRef.current = selectInputRef.current + e.key;
                wordNavigateOptions(e.key);
                setIsDebounce(true);
                break;
        }
    }, [arrowNavigateOptions, selectRef, selectInputRef.current]);
    return {
        handleKeyDown,
    };
};
//# sourceMappingURL=accessibility.js.map